import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import Avatar from '@jimmyboys/liita-ui/dist/components/Avatar'
import Tooltip from '@jimmyboys/liita-ui/dist/components/Tooltip'
import Icon from '@jimmyboys/liita-ui/dist/components/Icon'
import ModalOptions from '@jimmyboys/liita-ui/dist/components/ModalOptions'

import styles from './NotesWidget.module.sass'
import ExpandableWidget from 'components/ExpandableWidget/ExpandableWidget'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'

const NotesRow = (props) => {
	const { noteObj, i18n, deleteNote, updateNote } = props
	const { note, reminderDate, author, emphasize, processId } = noteObj

	const options = [
		[
			{
				value: 'update',
				text: i18n`Update note`,
				action: () => {
					updateNote &&
						updateNote({
							note: noteObj,
							processId,
						})
				},
			},
			{
				value: 'delete',
				text: i18n`Delete note`,
				action: () =>
					deleteNote &&
					deleteNote({
						note: noteObj,
						processId,
					}),
			},
		],
	]

	const titles = [i18n`Actions`]

	return (
		<HStack
			className={styles['note-row']}
			align='center'
			wrap='nowrap'
			columns={
				reminderDate
					? [0, 6, 3, '18px', '16px']
					: [0, 6, '18px', '16px']
			}
			gap='xsmall'
			justify='space-between'
		>
			<Tooltip
				className={styles['author']}
				text={author?.name || ''}
				displayDelay={700}
			>
				<span>
					<Avatar
						rounded
						className={styles['avatar']}
						user={author}
					/>
				</span>
			</Tooltip>
			<Tooltip
				className={styles['note-container']}
				content={
					<small className={styles['note-tooltip']}>{note}</small>
				}
				displayDelay={700}
			>
				<small>{note}</small>
			</Tooltip>
			<span>{reminderDate?.shortDateFormat}</span>
			{emphasize ? (
				<Tooltip text={i18n`Emphasized note`} displayDelay={700}>
					<Icon
						className={styles['emphasize-icon']}
						width='20px'
						height='20px'
						name={'star'}
					/>
				</Tooltip>
			) : (
				<span />
			)}
			<ModalOptions
				titles={titles}
				groups={options}
				options={options}
				corner='straight'
				onSelect={(item) => {
					item && item.action && item.action()
				}}
			>
				<button className={styles['notes-options']}>
					<Icon
						className={styles['more-icon']}
						name={'options'}
						width='16px'
						height='16px'
					/>
				</button>
			</ModalOptions>
		</HStack>
	)
}

export const renderNotes = (notes, i18n, deleteNote, updateNote) => {
	return notes?.length ? (
		notes.map((note) => (
			<NotesRow
				key={note.id}
				noteObj={note}
				i18n={i18n}
				deleteNote={deleteNote}
				updateNote={updateNote}
			/>
		))
	) : (
		<div className={styles['no-notes']}>{i18n`There are no notes.`}</div>
	)
}

const NotesWidget = (props) => {
	const { data } = props
	const { notes } = data
	const { i18n, deleteNote, updateNote } = useGlobal()

	return (
		<ExpandableWidget
			className={styles['root']}
			titleAppearance='aside-widget'
			arrowPosition='right'
			heading='h5'
			title={i18n`Notes`}
			collapsedLabel={notes?.length}
			icon='note-v2'
			expanded
			borderRadius
			paddings={['', 'xsmall', 'xsmall']}
			margins={['small', '', '']}
		>
			{notes?.length ? (
				notes.map((note) => (
					<NotesRow
						key={note.id}
						noteObj={note}
						i18n={i18n}
						deleteNote={deleteNote}
						updateNote={updateNote}
					/>
				))
			) : (
				<div
					className={styles['no-reminders']}
				>{i18n`There are no notes.`}</div>
			)}
		</ExpandableWidget>
	)
}

export default NotesWidget
